var __extends = this && this.__extends || function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
            d.__proto__ = b;
        } || function (d, b) {
            for (var p in b)
                if (b.hasOwnProperty(p))
                    d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator['throw'](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function (thisArg, body) {
    var _ = {
            label: 0,
            sent: function () {
                if (t[0] & 1)
                    throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
    return g = {
        next: verb(0),
        'throw': verb(1),
        'return': verb(2)
    }, typeof Symbol === 'function' && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f)
            throw new TypeError('Generator is already executing.');
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y['return'] : op[0] ? y['throw'] || ((t = y['return']) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [
                        op[0] & 2,
                        t.value
                    ];
                switch (op[0]) {
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [0];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2])
                        _.ops.pop();
                    _.trys.pop();
                    continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import React from 'react';
import {
    inject,
    observer
} from 'mobx-react';
import moment from 'moment';
import { createForm } from 'rc-form';
import { AccountBusiness } from '@business/account/login';
import './index.less';
import {
    Dialog,
    Loader
} from 'oned';
import { getClientContact } from '@common/utils/userProfile';
import {
    isMobile,
    sendAmplitude_Otp
} from '@common/utils';
import { AmplitudeEventName } from '@common/enums/base';
import { formatPhoneNumber } from '@common/utils/format';
var defaultValue = {
    errorMsg: '',
    isLoading: false,
    callCenter: '',
    showDialog: false
};
var OTPVerifyError = function (_super) {
    __extends(OTPVerifyError, _super);
    function OTPVerifyError(props) {
        var _this = _super.call(this, props) || this;
        _this.state = defaultValue;
        return _this;
    }
    OTPVerifyError.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, getClientInfo, getCallCenterPhone, tel, contactInfo;
            return __generator(this, function (_b) {
                switch (_b.label) {
                case 0:
                    this.setState({ isLoading: true });
                    _a = this.props, getClientInfo = _a.getClientInfo, getCallCenterPhone = _a.getCallCenterPhone;
                    return [
                        4,
                        getClientInfo()
                    ];
                case 1:
                    _b.sent();
                    return [
                        4,
                        getCallCenterPhone()
                    ];
                case 2:
                    tel = _b.sent();
                    if (tel !== null) {
                        this.setState({
                            callCenter: tel.replace(/\D/g, ''),
                            isLoading: false
                        });
                    } else {
                        contactInfo = getClientContact().tel;
                        this.setState({
                            callCenter: contactInfo,
                            isLoading: false
                        });
                    }
                    return [2];
                }
            });
        });
    };
    OTPVerifyError.prototype.onClicked = function () {
        var callCenter = this.state.callCenter;
        if (isMobile) {
            window.location.href = 'tel:' + callCenter;
        } else {
            this.setState({ showDialog: true });
        }
    };
    OTPVerifyError.prototype.render = function () {
        var _this = this;
        var _a = this.state, isLoading = _a.isLoading, callCenter = _a.callCenter, showDialog = _a.showDialog;
        return React.createElement(React.Fragment, null, React.createElement(Loader, {
            visible: isLoading,
            page: true
        }), React.createElement('div', { className: 'login-flex' }, React.createElement('div', { className: 'login-page' }, React.createElement('button', {
            className: 'navbar-toggler text-large go-back-small-screen',
            type: 'button',
            onClick: function () {
                history.back();
                sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Click_Back);
            }
        }, React.createElement('span', {
            className: 'iconfont icon-return',
            style: { fontSize: '14px' }
        }), 'Back'), React.createElement('div', { className: 'login-box' }, React.createElement('div', { className: 'default-padding py12' }, React.createElement('img', {
            className: 'sc-icon',
            src: 'https://rsp-front-end-stage.lessen.com/sources/svg/verifyOtpError.svg'
        })), React.createElement('div', { className: 'text-center' }, React.createElement('span', {
            style: {
                marginBottom: '2%',
                display: 'block'
            }
        }, React.createElement('b', null, 'Location Verification Failed')), ' ', React.createElement('br', null), React.createElement('span', null, 'We apologize but we are unable to locate your account with information you provided. Please contact our customer service for assistance.'), React.createElement('div', {
            className: 'form-group',
            style: {
                textAlign: 'center',
                marginTop: '5%'
            }
        }, React.createElement('a', {
            className: 'btn btn-submit btn-block',
            onClick: function () {
                _this.onClicked();
                sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Click_ContactUs);
            }
        }, 'Contact Us')))), React.createElement('p', { className: 'text-muted text-center' }, '\xA9 ', moment().utc().year(), ' Lessen, LLC. All Rights Reserved.')), React.createElement(Dialog, {
            visible: showDialog,
            title: 'Contact Us',
            closable: true,
            destroyOnClose: false,
            onClose: function () {
                return _this.setState({ showDialog: false });
            },
            animation: 'zoom',
            maskClosable: true,
            maskAnimation: 'fade',
            hasFooter: false,
            className: 'hack-dialog'
        }, React.createElement('div', { className: 'text-middle pb-4' }, 'Please contact our customer service at ', formatPhoneNumber(callCenter), ' for assistance.'))));
    };
    OTPVerifyError = __decorate([
        createForm(),
        inject(AccountBusiness),
        observer
    ], OTPVerifyError);
    return OTPVerifyError;
}(React.Component);
export default OTPVerifyError;